var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { $ } from '../util/view';
import CMPError from '../cmp-error';
import API from './api';
import BackendAPI from './backend';
import { requiresView } from './frontend-interface';
import ConsentModModel from '../model/consent-mod';
import consentFactory from '../model/consent-factory';
import { onContentLoaded } from '../util/dom';
import debug from '../util/debug';
export default class FrontendModAPI extends BackendAPI {
    static async load(backendBaseUrl, clientConsentString, geoInfo, legislation, pVendorList) {
        const { document: doc } = window;
        const iframe = $('iframe', {
            id: 'mol-ads-cmp-iframe',
            name: '__uspapiLocation',
            style: 'width:0;height:0;border:none;',
        }, [], doc).raw;
        const promise = new Promise((resolve, reject) => {
            const onLoad = async () => {
                const { contentWindow } = iframe;
                iframe.removeEventListener('load', onLoad);
                if (!contentWindow) {
                    reject(new CMPError("Couldn't successfully create CMP"));
                }
                resolve(new this(backendBaseUrl));
            };
            iframe.addEventListener('load', onLoad);
            iframe.addEventListener('error', reject);
            onContentLoaded(() => doc.body.appendChild(iframe));
        });
        return Promise.all([
            promise,
            super.load(backendBaseUrl, clientConsentString, geoInfo, legislation, pVendorList),
        ]).then(([, api]) => {
            ;
            api.iframe = iframe;
            return api;
        });
    }
    async init(clientConsentString, geoInfo, legislation, pVendorList) {
        debug('load consentModel');
        this.consentModel = await consentFactory(this.backendBaseUrl, ConsentModModel, clientConsentString, geoInfo, legislation, pVendorList);
        this.isReady = true;
        this.isSingleFrame = true;
        this.emit('ready');
    }
    consentToAll(origin = location.origin, callback = () => { }) {
        return super.consentToAll(origin, callback);
    }
    dissentToAll(origin = location.origin, callback = () => { }) {
        return super.dissentToAll(origin, callback);
    }
    openSettings(_, callback) {
        this.view.openSettings();
        callback(null, true);
    }
    closeSettings(_, callback) {
        this.view.closeSettings();
        callback(null, true);
    }
    giveThanks(_, callback) {
        this.view.alert();
        this.emit('thanksGiven');
        callback(null, true);
    }
    rendered(_, callback, count = 0) {
        if (this.view) {
            callback(null, true);
        }
        else if (count > 10) {
            callback(null, false);
        }
        else {
            setTimeout(() => this.rendered(_, callback, count + 1), 10);
        }
    }
    unload() {
        const { __uspapi: uspapi } = window;
        delete window.__uspapi;
        API.provision();
        for (const queueCommand of uspapi.a) {
            window.__uspapi.a.push(queueCommand);
        }
        if (!this.iframe) {
            this.iframe.remove();
        }
    }
}
__decorate([
    requiresView
], FrontendModAPI.prototype, "openSettings", null);
__decorate([
    requiresView
], FrontendModAPI.prototype, "closeSettings", null);
__decorate([
    requiresView
], FrontendModAPI.prototype, "giveThanks", null);
